module.exports = __webpack_public_path__ + "img/qr_gcqxd.50587760.png";